import React, { ReactNode } from 'react'

import withCondition from 'components/withCondition'

import { StyledHeader, StyledCloseIcon, StyledHeaderText } from './styles'

interface DialogHeaderProps {
  Header: string | ReactNode
  close?: () => void
}

function DialogHeaderComponent({ Header, close }: DialogHeaderProps) {
  if (typeof Header === 'string') {
    return (
      <StyledHeader>
        <StyledHeaderText>{Header}</StyledHeaderText>
        <StyledCloseIcon
          height={12}
          onClick={close}
          condition={!!close}
        />
      </StyledHeader>
    )
  }

  return Header
}

export const DialogHeader = withCondition(DialogHeaderComponent)
